import { lazy } from 'react';

export const SignInLiquid = lazy(() => import('./SignInLiquid.component'));
